/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BoatMastMaterial {
    Aluminium = 'Aluminium',
    Holz = 'Holz',
    Carbon = 'Carbon',
    Andere = 'Andere'
  }

    export const BoatMastMaterialTranslocoMap: Record<BoatMastMaterial, string> = {
    [BoatMastMaterial.Aluminium]: 'boatMastMaterial.aluminium',
    [BoatMastMaterial.Holz]: 'boatMastMaterial.holz',
    [BoatMastMaterial.Carbon]: 'boatMastMaterial.carbon',
    [BoatMastMaterial.Andere]: 'boatMastMaterial.andere',
    };

    export const BoatMastMaterialOptions = [
  { value: BoatMastMaterial.Aluminium, labelKey: 'boatMastMaterial.aluminium' },
  { value: BoatMastMaterial.Holz, labelKey: 'boatMastMaterial.holz' },
  { value: BoatMastMaterial.Carbon, labelKey: 'boatMastMaterial.carbon' },
  { value: BoatMastMaterial.Andere, labelKey: 'boatMastMaterial.andere' },
    ];

